import { TermsAndConditionsDTO } from '@/shared/api/model';
import { TermsAndConditionsType as ApiTermsAndConditionsType } from '@/shared/api/model';

// Re-export the DTO type
export type { TermsAndConditionsDTO };

// Export the TermsAndConditionsType enum directly rather than re-exporting
export const TermsAndConditionsType = ApiTermsAndConditionsType;

// ContentFormat enum for terms and conditions content
export enum ContentFormat {
  HTML = 'HTML',
  MARKDOWN = 'MARKDOWN',
  PLAIN_TEXT = 'PLAIN_TEXT'
}

// Define the filter interface
export interface TermsAndConditionsFilter {
  type?: typeof TermsAndConditionsType[keyof typeof TermsAndConditionsType];
  entityId?: string;
  showActive?: boolean;
}
